"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const fields_validators_1 = require("@App/helpers/work-entities/fields-validators");
const string_escape_newlines_1 = require("@App/helpers/string-escape-newlines");
const dayjs_1 = __importDefault(require("dayjs"));
const react_1 = __importDefault(require("react"));
const clsx_1 = __importDefault(require("clsx"));
const RecordingCardDetails = (props) => {
    const { label, duration, releaseDate } = props;
    return (react_1.default.createElement("div", { className: 'details-container' },
        react_1.default.createElement("p", { className: 'small-2' },
            react_1.default.createElement("span", { className: (0, clsx_1.default)((0, fields_validators_1.labelInvalidCheck)(label) && 'red-text bold') }, "Label:\u00A0"),
            react_1.default.createElement("strong", null, label ? (0, string_escape_newlines_1.stringEscapeNewlines)(label) : '')),
        react_1.default.createElement("p", { className: 'small-2' },
            react_1.default.createElement("span", { className: (0, clsx_1.default)((0, fields_validators_1.durationInvalidCheck)(duration) && 'red-text bold') }, "Duration:\u00A0"),
            react_1.default.createElement("strong", null, duration || '')),
        react_1.default.createElement("p", { className: 'small-2' },
            react_1.default.createElement("span", null, "Release date:\u00A0"),
            react_1.default.createElement("strong", null, releaseDate ? (0, dayjs_1.default)(releaseDate).format('MMMM DD YYYY') : ''))));
};
exports.default = RecordingCardDetails;
